import type { Axios } from "axios";

const route = "collections";

class CollectionsInterface {
  client: Axios;

  /**
   * constructor to set Axios client
   * @param client Axios client
   */
  constructor(client: Axios) {
    this.client = client;
    this.client.interceptors.request.use((config) => {
      config.params = config.params || {};
      if (!config.params["limit"]) {
        config.params["limit"] = "20";
      }
      if (!config.params["include_orders"]) {
        config.params["include_orders"] = false;
      }
      if (!config.params["order_direction"]) {
        config.params["order_direction"] = "desc";
      }

      return config;
    });
  }

  /**
   * Get all collections query
   * @param params Object of query params
   */
  async getAll(params?: { [key: string]: string | number }): Promise<any> {
    try {
      return this.client.get(route, { params }).then((r) => r.data);
    } catch (e: any) {
      console.error("Error ", e);
      throw new Error(e.toString());
    }
  }
}
export default CollectionsInterface;
